<template>
  <header :class="[isScrolled && !isMobile ? 'back-filter' : '']">
    <div class="header-bg">
      <div class="header-container">
        <div class="header-wrap">
          <div class="header-left">
            <Logo></Logo>
            <HNav v-if="!isMobile"></HNav>
          </div>
          <div class="header-right">
            <!-- <connect-wallet v-if="!isMobile">
              <template v-slot:btn>
                <ConnectWalletOuter />
              </template>
            </connect-wallet>
            <sign-in v-if="!isMobile">
              <template v-slot:btn>
                <SignInOuter />
              </template>
            </sign-in>
            <connect-wallet-account-button v-if="isMobile && user" round
              @click.native="$refs.cwDrawerRef.open = true"></connect-wallet-account-button>
            <sign-in-account-button v-if="isMobile && user" round
              @click.native="$refs.siDrawerRef.open = true"></sign-in-account-button> -->
            <Menu style="margin-left: 4px;" v-if="isMobile" @click.native="openMenu"></Menu>
          </div>
        </div>
      </div>
    </div>

    <!-- <cw-drawer-cell ref="cwDrawerRef"></cw-drawer-cell>
    <si-drawer-cell ref="siDrawerRef"></si-drawer-cell> -->
  </header>
</template>

<script>
import Menu from "./components/menu";
import Logo from "./components/logo";
import HNav from "./components/nav";
import MobileNav from "./components/mobileNav";
import CustomButton from "../components/customButton";
// import ConnectWallet from "../components/connectWallet";
// import SignIn from "../components/signIn";
// import ConnectWalletAccountButton from "../components/connectWallet/accountButton.vue";
// import SignInAccountButton from "../components/signIn/accountButton.vue";
import responsiveMixin from "@/mixins/responsive";
// import cwDrawerCell from "../components/connectWallet/drawerCell.vue";
// import siDrawerCell from "../components/signIn/drawerCell.vue";
// import ConnectWalletOuter from "./components/connectWallet/index.vue";
// import SignInOuter from "./components/signIn/index.vue";
import { mapState } from "vuex";
import Bus from "@/libs/bus";

export default {
  name: "HeaderWrap",
  mixins: [responsiveMixin],
  data() {
    return {
      isScrolled: false
    }
  },
  props: {},
  components: {
    Menu, Logo, HNav, CustomButton, MobileNav,
    // ConnectWallet, SignIn,
    // ConnectWalletAccountButton, SignInAccountButton,
    // cwDrawerCell, siDrawerCell,
    // ConnectWalletOuter, SignInOuter
  },
  computed: {
    ...mapState({
      user: (state) => state.user.name || "",
    })
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      requestAnimationFrame(() => {
        // 0.7 根据 matr1xFireRole index.vue 中ScrollTrigger start 的 (i - 0.3) * innerHeight
        this.isScrolled = window.scrollY > 0.7 * window.innerHeight;
      });
    },
    openMenu() {
      Bus.$emit("is-open-menu", {
        slot: MobileNav, open: true, fill: "rgba(18, 17, 16, 0.7)"
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>